module.exports = "../../app/cells/pages/landing_playground/index/header_cell.rb";